module.exports = "<section class=\"container\">\r\n\t<section class=\"main\">\r\n\t\t<h2>NAAC </h2>\r\n\t\t<br>\r\n\t\t<div class=\"content\" [innerHtml]=\"content\" *ngIf=\"isLoaded\">\r\n\t\t</div>\r\n\t\t<div *ngIf=\"!isLoaded\" class=\"loading\">\r\n\t\t\t<mat-spinner color=\"warn\"></mat-spinner>\r\n\t\t</div>\r\n\t</section>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/naac/naac.component.html
// module id = ./src/app/components/naac/naac.component.html
// module chunks = main